// NPM
import { omitBy, isNil } from "lodash"
import { Helmet } from "react-helmet"
import { useTranslation } from "react-i18next"
import React, { useEffect, useState } from "react"

// HOOKS
import usePagination from "Hooks/pagination.hook"

// SERVICES
import { listLines } from "Services/delivery-settings.services"

// COMPONENTS
import ModuleTitleBar from "Components/shared/module-title-bar"
import { LineList } from "Components/delivery-management/delivery-lists"

const DeliveryLines: React.FC<any> = () => {
    const { t } = useTranslation()

    const initialFilters: any = {}

    const [response, setResponse] = useState<any>([])
    const [filters, setFilters] = useState<any>(initialFilters)
    const [currentListCount, setCurrentListCount] = useState(0)
    const { paginationComponent, itemPerPage, queryParams } = usePagination({
        currentListCount,
    })

    useEffect(() => {
        handleFetchLines(filters)
    }, [filters, queryParams.offset, itemPerPage])

    const handleFetchLines = async (filters?: any) => {
        const responseData = await listLines(
            omitBy(filters, isNil),
            queryParams.offset,
            itemPerPage
        )
        if (responseData && !responseData.error) {
            setResponse(responseData)
            setCurrentListCount(responseData.length)
        }
    }

    const handleFilters = (filterInput) => {
        setFilters({
            type: filterInput.byType || null,
            line: filterInput.byLine || null,
            orFields: filterInput.orFields || null,
        })
    }

    return (
        <div className="delivery-management lines">
            <Helmet>
                <title>{t("pageTitle.lines")}</title>
            </Helmet>

            <ModuleTitleBar
                titleText={t("title.lines")}
            />

            <LineList
                list={response}
                onFilter={handleFilters}
            />
            <div className="my-30">
                {paginationComponent}
            </div>
        </div>
    )
}

export default DeliveryLines